import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { DISCOUNT_MULTI_FOR_MULTI_QUERY } from "./schema";

export const useDiscountMultiForMultiQuery = (hotelID: string, discountId: string) => {
	const { data } = useCustomSuspenseQuery(DISCOUNT_MULTI_FOR_MULTI_QUERY, {
		variables: { hotelID, discountId, discountListHotelId2: hotelID },
		fetchPolicy: "no-cache",
	});

	return {
		discountMultiForMultiServerModel: data,
	};
};
